import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  colors,
  CardMedia,
} from "@mui/material";
import { BorderBottom } from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import { useAuth } from "context/authContext";

const ReceiptData = () => {
  const { currentUser } = useAuth();
  const location = useLocation();
  // const payment = location.state;
  const transactionData = location.state;
  const transactionDataArray = Array.isArray(transactionData)
    ? transactionData
    : [transactionData]; // Wrap in array if it's a single object


  return (
    <Box sx={styleSheet.mainContainer}>
      <Box sx={styleSheet.headerContainer}>
        <Box sx={styleSheet.headerSecondCon}>
          <Box>
            <Typography variant="h4" component="div">
              <CardMedia
                sx={styleSheet.headerLogo}
                image={"/assets/icons/affektilogo.png"}
              />
              {/* <img src="/assets/icons/affektilogo.png" alt="Affekti" style={styleSheet.headerLogo} /> */}
            </Typography>
          </Box>
          <Box sx={styleSheet.receiptCon}>
            <Typography sx={styleSheet.para}>
              Figma ipsum component variant
            </Typography>
            <Typography sx={styleSheet.para}>Figma ipsume</Typography>
            <Typography sx={styleSheet.para}>Figma</Typography>
          </Box>
          <Box sx={styleSheet.receiptCon}>
            <Typography sx={styleSheet.para}>website</Typography>
            <Typography sx={styleSheet.para}>email here</Typography>
            <Typography sx={styleSheet.para}>Phone Number goes here</Typography>
          </Box>
        </Box>

        {transactionDataArray.map((item: any) => (
          <>
            <Box sx={styleSheet.mainHeading}>
              <Typography
                fontWeight={{ xs: 600, md: 700 }}
                fontSize={{ xs: 12, md: 28 }}
              >
                Receipt {item?.transactionId || "#0712"}
              </Typography>
            </Box>

            <Box key={item?.transactionId} sx={styleSheet.paraContainer}>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  sx={styleSheet.receiptHeading}
                >
                  Billed To:
                </Typography>
                <Typography sx={styleSheet.receiptPara}>
                  {/* Serra Ozkaragoz */}
                  {currentUser?.userInfo?.firstName}{" "}
                  {currentUser?.userInfo?.lastName}
                </Typography>
                <Typography sx={styleSheet.receiptPara}>
                  3453 Glenville Ave,
                </Typography>
                <Typography sx={styleSheet.receiptPara}>
                  Dallas, Texas
                </Typography>
                <Typography sx={styleSheet.receiptPara}>45734</Typography>
              </Box>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  sx={styleSheet.receiptHeading}
                >
                  Purchase Date:
                </Typography>
                <Typography sx={styleSheet.receiptPara}>
                  {/* October, 7 2020 */}

                  {item?.createdAt
                    ? item.createdAt.seconds
                      ? new Date(
                        item.createdAt.seconds * 1000
                      ).toLocaleDateString("en-US", {
                        month: "short",
                        day: "2-digit",
                        year: "numeric",
                      })
                      : typeof item.createdAt === "string"
                        ? new Date(item.createdAt).toLocaleDateString("en-US", {
                          month: "short",
                          day: "2-digit",
                          year: "numeric",
                        })
                        : "Invalid Date"
                    : "N/A"}
                </Typography>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  sx={styleSheet.receiptHeading}
                >
                  Invoice Number:
                </Typography>
                <Typography sx={styleSheet.receiptPara}>0712</Typography>
              </Box>
              <Box
                sx={{
                  display: { xs: "none", md: "flex" },
                  flexDirection: "column",
                  gap: "2px",
                }}
              >
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  sx={styleSheet.receiptHeading}
                >
                  Total Amount:
                </Typography>
                <Typography
                  variant="h4"
                  fontWeight={600}
                  fontSize={32}
                  color={"#233F91"}
                >
                  ${item?.amount}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: { xs: "flex", md: "none" },
                flexDirection: "column",
                gap: "2px",
                ml: "34px",
              }}
            >
              <Typography
                variant="subtitle1"
                gutterBottom
                sx={styleSheet.receiptHeading}
              >
                Total Amount:
              </Typography>
              <Typography
                variant="h4"
                fontWeight={600}
                fontSize={{ xs: 13.9, md: 32 }}
                color={"#233F91"}
              >
                ${item?.amount}
              </Typography>
            </Box>
            <Box sx={styleSheet.mainHeading}>
              <Typography
                fontWeight={{ xs: 600, md: 700 }}
                fontSize={{ xs: "10.42px", md: 28 }}
              >
                Details
              </Typography>
            </Box>
            <TableContainer component={Paper} sx={styleSheet.tableContainer}>
              <Table>
                <TableHead>
                  <TableRow sx={{ BorderBottom: "none" }}>
                    <TableCell
                      // width={500}
                      sx={{
                        ...styleSheet.tableColumn,
                        width: { xs: "52%", md: "500px" },
                      }}
                    >
                      Description
                    </TableCell>
                    <TableCell width={166.66} sx={styleSheet.tableColumn}>
                      Cost
                    </TableCell>
                    <TableCell width={166.66} sx={styleSheet.tableColumn}>
                      Qty
                    </TableCell>
                    <TableCell width={166.66} sx={styleSheet.tableColumn}>
                      Amount
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* Figma ipsum component variant main layer. Strikethrough. */}
                  {item?.cartItemData?.map((cartItem: any, index: number) => (
                    <>
                      {cartItem?.contentData?.type === "course" && (
                        <TableRow key={`course-${index}`}>
                          <TableCell sx={styleSheet.tableCourseContainer}>
                            <Typography sx={styleSheet.receiptHeading}>
                              Course
                            </Typography>
                            <Typography key={index} sx={styleSheet.rowFigma}>
                              {cartItem?.contentData?.title ||
                                "No Title Available"}
                            </Typography>
                          </TableCell>
                          <TableCell sx={styleSheet.rowText}>
                            ${cartItem?.contentData?.price}
                          </TableCell>
                          <TableCell sx={styleSheet.rowText}>
                            {cartItem?.quantity || "No Quantity Available"}
                          </TableCell>
                          <TableCell sx={styleSheet.rowText}>
                            ${cartItem?.contentData?.price}
                          </TableCell>
                        </TableRow>
                      )}
                      {cartItem?.contentData?.type === "handout" && (
                        <TableRow key={`handout-${index}`}>
                          <TableCell
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "4px",
                              borderBottom: "none",
                            }}
                          >
                            <Typography sx={styleSheet.receiptHeading}>
                              Handout
                            </Typography>
                            <Typography
                              variant="body2"
                              color="textSecondary"
                              sx={styleSheet.rowFigma}
                            >
                              {cartItem?.contentData?.title ||
                                "No Title Available"}
                            </Typography>
                          </TableCell>
                          <TableCell sx={styleSheet.rowText}>
                            ${cartItem?.contentData?.price}
                          </TableCell>
                          <TableCell sx={styleSheet.rowText}>
                            {" "}
                            {cartItem?.quantity || "No Quantity Available"}
                          </TableCell>
                          <TableCell sx={styleSheet.rowText}>
                            ${cartItem?.contentData?.price}
                          </TableCell>
                        </TableRow>
                      )}
                    </>
                  ))}
                </TableBody>
              </Table>
              <TableRow sx={styleSheet.totalContainer}>
                <TableCell sx={{ borderBottom: "none" }}>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: { xs: "6.95px", md: "16px" },
                      color: "#233F91",
                    }}
                  >
                    Total Amount
                  </Typography>
                </TableCell>
                <TableCell sx={{ borderBottom: "none" }}>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: { xs: "6.08px", md: "14px" },
                      color: { xs: "#3B3B3B", md: "#233F91" },
                      marginRight: { xs: "13px", md: "50px" },
                    }}
                  >
                    ${item?.amount}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableContainer>
          </>
        ))}
      </Box>
    </Box>
  );
};

export default ReceiptData;

const styleSheet = {
  mainContainer: {
    p: { xs: 1, md: 5 },
    width: { xs: "88%", md: "1107px" },
    margin: "auto",

  },
  headerContainer: {
    margin: "auto",
    border: "1px solid #ccc",
    borderRadius: "8px",
    backgroundColor: "#fff",
    boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
  },
  headerSecondCon: {
    display: "flex",
    alignItems: "center",
    gap: { xs: 3, md: 20 },
    marginBottom: "16px",
    padding: "20px",
    backgroundColor: "#E0ECFC",
    borderRadius: "8px 8px 0 0",
  },
  headerLogo: {
    width: { xs: "85.11px", md: "196px" },
    height: { xs: "33.6px", md: "77.37px" },
    paddingLeft: "40px",
  },
  paraContainer: {
    display: "flex",
    marginLeft: "16px",
    gap: { xs: 5, md: 30 },
    marginBottom: "16px",
    padding: "20px",
  },
  receiptCon: {
    display: "flex",
    flexDirection: "column",
    gap: { xs: "5px", md: "8px" },
  },
  para: {
    fontFamily: "Poppins, sans-serif",
    fontWeight: 300,
    fontSize: { xs: "5px", md: "12px" },
    lineHeight: { xs: "6.25px", md: "14.4px" },
    marginBottom: { xs: "0px", md: "4px" },
    letterSpacing: "2%",
    color: "#7A7A7A",
    borderBottom: "none",
  },
  receiptHeading: {
    fontWeight: 700,
    fontSize: { xs: "7.82px", md: "18px" },
    lineHeight: { xs: "9.38px", md: "21.6px" },
    borderBottom: "none",
    color: { xs: "#A3A3A3", md: "" },
  },
  receiptPara: {
    fontFamily: "Poppins, sans-serif",
    fontWeight: 500,
    fontSize: { xs: "6.95px", md: "16px" },
    lineHeight: { xs: "8.34px", md: "19.2px" },
    marginBottom: "4px",
    letterSpacing: "2%",
    color: "#3B3B3B",
    borderBottom: "none",
  },
  tableColumn: {
    fontWeight: "600",
    fontSize: { xs: "6.95px", md: "16px" },
    color: "#233F91",
    borderBottom: "none",
    padding: "16px",
  },
  tableContainer: {
    borderRadius: "8px",
    backgroundColor: "#E5ECFF",
    width: { xs: "88%", md: "1037px" },
    margin: "auto",
    marginBottom: "30px",
    borderBottom: "none",
  },
  tableCourseContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    borderBottom: "none",
  },
  rowText: {
    fontFamily: "Atten Round New",
    fontWeight: 500,
    fontSize: { xs: "6.08px", md: "14px" },
    lineHeight: { xs: "10.42px", md: "16.8px" },
    marginBottom: "4px",
    letterSpacing: "2%",
    color: "#3B3B3B",
    borderBottom: "none",
  },
  rowFigma: {
    fontWeight: 400,
    fontSize: { xs: "7.38px", md: "17px" },
    lineHeight: { xs: "10.42px", md: "24px" },
    letterSpacing: { xs: "-1%", md: "21%" },
    color: "#7A7A7A",
    borderBottom: "none",
  },
  totalContainer: {
    textAlign: "right",
    padding: { xs: "0px", md: "16px" },
    display: "flex",
    gap: { xs: "32px", md: "40px" },
    justifyContent: "flex-end",
    marginLeft: { xs: "41px", md: "0px" },
  },
  mainHeading: {
    padding: "16px",
    marginLeft: "16px",
  },
};
